import type { HighlightingSlice, HighlightingState, ViewerSliceCreator } from "./types";

export const highlightingInitialState: HighlightingState = {
  highlightedMeshUuids: [],
};

export const createHighlightingSlice: ViewerSliceCreator<HighlightingSlice> = (set) => ({
  ...highlightingInitialState,

  setHighlight: (msg) =>
    set((state) => {
      state.highlightedMeshUuids = msg.mesh_uuids;
    }),
});
